import React, { useEffect } from "react";
import "./Firebase";
import MapCanvas from "./Map";

const Main = props => {
  useEffect(() => {
    if (!props.user.name) {
      props.history.push("/login");
    }
  });

  return (
    <div>
      <MapCanvas />
    </div>
  );
};

export default Main;
